import { planningEngineService } from '@libs/data-access/queries'
import { defineModal, Modal } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import { useDispatch } from 'react-redux'

import { entitiesActions } from '../../redux/modules/entities'

type UnpublishModalProps = {
  weeklyscheduleId: number
}

export const unpublishModalDef = defineModal<UnpublishModalProps>({
  name: 'unpublishModal'
})

const UnpublishModal: FC = () => {
  const { close, isOpen, data } = unpublishModalDef.useModal()
  const { t, tCommon } = usePlanningFormTranslation()
  const dispatch = useDispatch()

  if (!data) {
    return null
  }

  return (
    <Modal variant='center' opened={isOpen} onClose={close}>
      <Modal.Header title={t('unpublishForm.title')} />
      <Modal.Content>{t('unpublishForm.text')}</Modal.Content>
      <Modal.Footer>
        <Modal.Footer.Danger
          data-testid='confirm-unpublish-week-button'
          onClick={() => {
            dispatch(
              entitiesActions.unpublishWeeklyscheduleById({
                weeklyscheduleId: data.weeklyscheduleId
              })
            )
            planningEngineService.header.invalidateHeader()
            close()
          }}
        >
          {tCommon('action.unpublish')}
        </Modal.Footer.Danger>
      </Modal.Footer>
    </Modal>
  )
}
export default unpublishModalDef.withModalShow(UnpublishModal)
